import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";
import missionImage from "@/assets/mission-yacht.jpg";

const OurMission = () => {
  const ease = [0.22, 1, 0.36, 1] as const;
  const { t } = useLanguage();

  return (
    <section id="mission" className="section-spacing bg-background">
      <div className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            className="overflow-hidden"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.4, ease }}
          >
            <img
              src={missionImage}
              alt={t("Luxury yacht cruising the Mediterranean coastline", "Luxe jacht langs de Mediterrane kustlijn")}
              className="w-full h-[400px] md:h-[520px] lg:h-[600px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.4, delay: 0.15, ease }}
          >
            <span className="font-label text-bronze block mb-8">
              {t("Our Mission", "Onze Missie")}
            </span>

            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-foreground leading-[1.1] mb-8">
              {t("Redefining the way the", "De manier waarop de")}
              <br />{t("world is experienced.", "wereld wordt ervaren herdefiniëren.")}
            </h2>

            <div className="divider-subtle mb-8" />

            <div className="space-y-6">
              <p className="font-body text-muted-foreground text-sm md:text-base leading-[1.9]">
                {t(
                  "We believe that true luxury is not found in excess, but in ease — in the quiet confidence that every detail has already been considered. Across the world's most sought-after destinations, we curate experiences that allow our clients to move through each place effortlessly, with complete privacy and freedom.",
                  "Wij geloven dat ware luxe niet wordt gevonden in overvloed, maar in gemak — in het stille vertrouwen dat elk detail al is overwogen. Op 's werelds meest gewilde bestemmingen stellen wij ervaringen samen die onze klanten in staat stellen moeiteloos door elke plek te bewegen, met volledige privacy en vrijheid."
                )}
              </p>

              <p className="font-body text-muted-foreground text-sm md:text-base leading-[1.9]">
                {t(
                  "From private villas and yachts to seamless transport, exceptional dining, wellness and carefully selected hotel partnerships, every element is arranged with discretion and precision. What remains is space — to arrive, to explore, and to enjoy each destination at its natural rhythm.",
                  "Van privévilla's en jachten tot naadloos vervoer, uitzonderlijk dineren, wellness en zorgvuldig geselecteerde hotelpartnerschappen — elk element wordt geregeld met discretie en precisie. Wat overblijft is ruimte — om aan te komen, te ontdekken en elke bestemming op haar natuurlijke ritme te genieten."
                )}
              </p>

              <p className="font-accent text-foreground/80 text-base md:text-lg italic pt-2">
                {t(
                  "Our role is simple: to make the extraordinary feel effortless.",
                  "Onze rol is eenvoudig: het buitengewone moeiteloos laten aanvoelen."
                )}
              </p>

              <p className="font-label text-bronze text-xs tracking-widest pt-4">
                {t(
                  "Discover the philosophy behind Arzani Group Worldwide.",
                  "Ontdek de filosofie achter Arzani Group Worldwide."
                )}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
